import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'
import { useOrderStore } from '../store'

const createOrder = async (data: any): Promise<any> => {
  const result = await axios.post(`orders`, data)
  return result
}

export function useCreateOrder() {
  const queryClient = useQueryClient()
  // const navigate = useNavigate()
  const resetForm = useOrderStore.useResetForm()

  return useMutation(createOrder, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('proposal')
      queryClient.invalidateQueries('notifications')
      queryClient.invalidateQueries('orderActions')
      queryClient.clear()
      resetForm()
      toast.success('Pedido criado com sucesso!')
      // navigate('/orders')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível criar o pedido!')
    }
  })
}
